// Port of api/fuel/app/classes/filter/package/lists/listing/data/games.php
export default {
	priority: 100,
	run: function(filter, data, config, global) {
		global.games = {}
		var listIds = Object.keys(global.editions || {})
		for (var i = 0; i < listIds.length; i++) {
			var editions = global.editions[listIds[i]] || []
			for (var j = 0; j < editions.length; j++) {
				global.games[editions[j].get_id()] = editions[j].get_indexed_games(5)
			}
		}
	}
}
